<template>
  <div>
    <head-nav-bar :title="title" :fixed="true" left-arrow />
    <div class="mt-header-nav">
      <div>
        <table class="order-table">
          <thead>
            <tr>
              <th>房型</th>
              <th width="15%">价格</th>
              <th width="15%">总房量</th>
              <th width="15%">允许超订</th>
              <th width="15%">可预订</th>
              <th width="25%">预订数量</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dItem, index) in roomData.Details" :key="index">
              <td>{{ dItem.RoomTypeName }}</td>
              <td>{{ dItem.RoomTypePrice }}</td>
              <td>{{ dItem.TotalRoomCount }}</td>
              <td>{{ dItem.OversellNum }}</td>
              <td>{{ dItem.Available }}</td>
              <td>
                <van-field
                  class="ipt-num"
                  type="digit"
                  v-model="dItem.OrderRoomCount"
                  @keyup="onChangeNumber($event, dItem)"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <van-goods-action>
          <div class="total" slot="default">
            <small>合计：</small>{{ totalNumber }}
          </div>
          <van-goods-action-button
            type="info"
            text="预定"
            :disabled="!totalNumber"
            @click="onSubmit"
          />
        </van-goods-action>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from "moment";
import groupOrderApi from "../../api/group_order.js";
// import roomApi from "@/api/room.js";
import { mapState, mapActions } from "vuex";
import {
  Row,
  Col,
  Button,
  Field,
  Cell,
  CellGroup,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Notify,
} from "vant";
import { ls } from "@/utils/cache.js";
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Notify.name]: Notify,
  },
  data() {
    return {
      roomData: {},
      companyId: "",
      title: "",
      dateRange: [],
      totalNumber: 0,
      roomOptions: {},
    };
  },
  created() {
    this.companyId = this.$route.query.Id;
    this.title = this.$route.query.Name;
    this.dateRange = ls.get("current_daterange");
    this.getData();
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  methods: {
    ...mapActions(["setRoomInfo"]),
    onSubmit() {
      const roomList = [];
      this.roomData.Details.forEach(v => {
        if (v.OrderRoomCount && v.OrderRoomCount > 0) {
          for (let i = 0; i < v.OrderRoomCount; i++) {
            const item = {
              daterange: [this.dateRange[0], this.dateRange[1]],
              baseDaterange: [this.dateRange[0], this.dateRange[1]],
              roomId: "",
              roomNo: "",
              roomTypeId: v.RoomTypeId,
              roomTypeName: v.RoomTypeName,
              price: v.RoomTypePrice,
              Persons: [],
              priceStructure: "",
              disabled: {
                disabledStart: false,
                disabledEnd: false,
              },
            };
            roomList.push(item);
          }
        }
      });
      this.roomOptions.gridData = roomList;
      this.roomOptions.actionType = "order";
      this.roomOptions.CompanyId = this.companyId;
      this.roomOptions.jumpToName = "groupCentralOrder";
      this.setRoomInfo(this.roomOptions);
      this.$router.push({ name: "groupRoomOrder" });
    },
    getData() {
      const params = {
        CompanyId: this.companyId,
        BeginDate: this.dateRange[0],
        EndDate: this.dateRange[1],
        PageIndex: 0,
        PageSize: 10,
      };
      groupOrderApi.GetGroupBookingList(params).then(res => {
        this.roomData = res.Data.Datas[0];
        this.roomData.Details.forEach((v, index) => {
          v.key = index;
          v.Available = Number(v.OversellNum) + Number(v.AvailableRoomCount);
          return v;
        });
      });
    },
    //选择预订房间数量
    onChangeNumber(e, record) {
      if (e.target.value > record.AvailableRoomCount) {
        Notify({
          type: "danger",
          message: "超过最大可预订数：" + record.AvailableRoomCount,
        });
        record.OrderRoomCount = record.AvailableRoomCount;
      }
      let total = 0;
      this.roomData.Details.forEach(element => {
        if (element.OrderRoomCount) {
          total += Number(element.OrderRoomCount);
        }
      });
      this.totalNumber = total;
    },
  },
};
</script>
<style lang="less" scoped>
.order-table {
  width: 100%;
  th,
  td {
    font-size: 12px;
    text-align: center;
  }
  th {
    font-weight: normal;
    background: #09a8d1;
    padding: 8px 0;
    color: #fff;
  }
  td {
    border-bottom: 1px dashed #ddd;
    &:first-child {
      font-size: 13px;
    }
    &:nth-child(2) {
      color: #f60;
    }
    .ipt-num {
      padding: 0.1rem 0.42667rem;
      /deep/ input {
        border: 1px solid #ddd;
        border-radius: 3px;
        padding: 0 5px;
      }
    }
  }
}
.total {
  color: #f00;
  font-size: 18px;
  line-height: 1.06667rem;
  padding: 0 10px;
}
</style>
